var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"certificate-preview"},[(_vm.certificate.viewSrc)?_c('iframe',{attrs:{"src":_vm.certificate.viewSrc,"frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }